import { Directive } from '@angular/core';

@Directive({
  selector: '[guildyMovable]'
})
export class GuildyMovableDirective {

  constructor() { }

}
